import { Box, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { useState } from "react";
import Button from "../../../../components/ui/Button";
import Input from "../../../../components/ui/Input";
import Text from "../../../../components/ui/Text";

export const DeleteGroupDialog = ({
  groupName,
  open,
  onClose,
  onDelete,
  isDeleting,
}) => {
  const [value, setValue] = useState("");

  const handleInputChange = (e) => {
    setValue(e.target.value);
  };

  const handleDelete = () => {
    setValue("");
    onDelete();
  };

  const handleClose = () => {
    setValue("");
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: "12px",
            m: 2,
          },
        },
      }}
    >
      <DialogTitle sx={{ p: 3, pb: 1 }}>
        <Text variant="pageHeader" sx={{ fontSize: "20px" }}>
          Delete Group
        </Text>
      </DialogTitle>

      <DialogContent sx={{ px: 3, py: 2 }}>
        <Text component="p" variant="paragraph">
          Are you sure you want to delete this group? This action cannot be
          undone.
        </Text>
        <Text component="p" variant="paragraph" sx={{ my: 2 }}>
          Any upcoming games will be cancelled and any players who have paid
          through the app will be refunded.
        </Text>
        <Input label="Group name" value={value} onChange={handleInputChange} />
        <Text component="p" variant="paragraph" sx={{ opacity: 0.65 }}>
          Type <b>{groupName}</b> to continue.
        </Text>
      </DialogContent>

      <Box
        sx={{
          p: 3,
          pt: 1,
          gap: 1,
          display: "flex",
          flexDirection: { xs: "column-reverse", sm: "row" },
          justifyContent: "flex-end",
        }}
      >
        <Button
          sx={{ width: "auto" }}
          variant="secondary"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleDelete}
          disabled={isDeleting || value !== groupName}
          sx={{
            m: 0,
            width: "auto",
            backgroundColor: "#FF4D4F",
            borderColor: "#FF4D4F",
            "&:hover": {
              backgroundColor: "#FF4D4F",
              borderColor: "#FF4D4F",
              opacity: 0.9,
            },
          }}
        >
          Delete
        </Button>
      </Box>
    </Dialog>
  );
};
